module.exports = __webpack_public_path__ + "static/media/lion.bcdefed3.png";